export default class Select {
  constructor(el, options = {}) {
    this.callback = options.callback || false;
    this.label = el.querySelector('[data-select-label]');
    this.select = el.querySelector('[data-select]');

    this.onChange = this._onChange.bind(this);

    this.select.addEventListener('change', this.onChange);
  }

  _onChange() {
    const text = this.select[this.select.selectedIndex].text;
    const value = this.select[this.select.selectedIndex].value;

    this.label.innerText = text;

    if (this.callback) {
      this.callback(value);
    }
  }

  unload() {
    this.select.removeEventListener('change', this.onChange);
  }
}
